import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const BikeShop = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my bike shop business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps bike shop businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for bike shop businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most bike shop businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my bike shop business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like bike shop. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Bike Shop - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Bike Shop CRM", url: "/industries/bike-shop" }
  ];

  const industryData = {
    name: 'Bike Shop',
    title: 'Increase Service Department Revenue & Build Cycling Community',
    subtitle: 'Automate tune-up reminders, capture walk-in inquiries, and build a loyal customer base',
    icon: '🚴',
    challenges: [
      'Service department underutilized',
      'Customers forget about annual tune-ups',
      'Walk-ins leave without connecting',
      'Hard to build community engagement',
      'Seasonal revenue fluctuations'
    ],
    solutions: [
      'Service reminder automation',
      'Annual tune-up campaigns',
      'In-store lead capture system',
      'Group ride and event automation',
      'Winter indoor training upsells'
    ],
    features: [
      'Customer CRM with bike profiles',
      'Service scheduling',
      'Maintenance reminders',
      'Event/group ride management',
      'Loyalty program tracking',
      'New bike arrival alerts',
      'Trade-in program',
      'Review automation'
    ],
    results: [
      '3x service department revenue',
      '70% annual tune-up conversion',
      'Consistent year-round sales',
      '£6.7K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Bike Shop UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for bike shop businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for bike shop UK, bike shop business software, bike shop customer management, bike shop lead generation UK"
        url="/industries/bike-shop"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default BikeShop;